<template>
  <mtCard
      :icon="dataTask.icon.name"
      :icon-color="dataTask.icon.color"
      :icon-bg-color="dataTask.icon.bgColor"
      :class="computedClasses"
  >
    <template #header>
      <div class="test-card__header-row">
        <mtChip class="test-card__type">{{ dataTask.type.label }}</mtChip>
        <app-tooltip
            top
            v-if="(!dataTask.isAvailableForExport) && (dataTask.type.value !== 'expert')"
        >
          <template #activator>
            <button
                class="test-card__download-btn"
                @click="OpenImportDialog()"
            >
              <mtSvg
                  class="test-card__download-btn__icon"
                  name="export"
                  width="10"
                  height="14"
              />
            </button>
          </template>
          <span style="white-space: nowrap">Импортировать файл сеанса</span>
        </app-tooltip>
        <app-tooltip
          top
          v-if="dataTask.isAvailableForExport"
        >
          <template #activator>
            <button
              class="test-card__download-btn"
              @click="openDownloadReportPopover()"
            >
              <mtSvg
                class="test-card__download-btn__icon"
                name="download"
                width="10"
                height="14"
              />
            </button>
          </template>
          <span style="white-space: nowrap">Скачать отчет</span>
        </app-tooltip>
      </div>
    </template>
    <template #content>
      <div class="test-card__text">
        <h2 class="test-card__title">{{ dataTask.name }}</h2>
        <mtShowMoreText
            class="test-card__description"
            height="67px"
        >
          <p><span v-html="dataTaskDescriptionWithLinks"></span></p>
        </mtShowMoreText>

        <div
            class="alert"
            v-if="dataTask.duration"
        >
          <mtSvg
              class="alert__icon"
              name="timerfilled"
              color="#a3a3a3"
              width="15"
          />
          {{ dataTask.duration }} минут
        </div>

        <plan-test-time :item="dataTask"/>
        <div
            class="test-card__info"
            v-if="dataTask.group"
        >
          <mtSvg
              class="test-card__info__icon"
              name="group"
              color="#00788C"
              width="15"
          />
          <p>Группа: {{ dataTask.group }}</p>
        </div>
        <div
            :class="['test-card__info', {
              'test-card__info--green': dataTask.attemptsAmount > 0 && dataTask.attemptsAmount > dataTask.attempts,
            }]"
        >
          <mtSvg
              class="test-card__info__icon"
              name="refresh-bg"
              color="#00788C"
              width="15"
          />
          <!-- neoside/bhbs-1004/add_large_text_to_the_task -->
          <!-- <p v-if="dataTask.attemptsAmount === -1">Кол-во попыток: ∞</p>
          <p v-else>Использовано попыток: {{ dataTask.attempts }} из {{ dataTask.attemptsAmount }}</p> -->

          <p v-if="dataTask.attemptsAmount === -1">
            Кол-во попыток: ∞
          </p>
          <p v-else :style="dataTask.attemptsAmount > 1 && dataTask.attempts !== dataTask.attemptsAmount ? 'color: #FF4C4C; font-size: 16px;' : ''">
            Использовано попыток: {{ dataTask.attempts }} из {{ dataTask.attemptsAmount }}
          </p>
          <!-- neoside/bhbs-1004/add_large_text_to_the_task -->
        </div>
        <file-download-card
            :links="dataTask.materials"
            link-label="fileName"
            link-value="originalUrl"
        />
      </div>
      <div class="test-card__footer">
        <div
            class="test-card__points"
            v-if="(test.balls && test.balls.current !== 0) && !test.is_calculating && show_progress"
        >
          Баллы: {{ test.balls.current }} из {{ test.balls.total }}
        </div>
        <mt-button
            :class="[
                'test-card__button',
                'test-card__button_' + dataTask.btn.className
              ]"
            :loading="dataTask.btn.loading"
            :disabled="dataTask.type.value !== 'expert' && !dataTask.isOpened"
            @click="dataTask.type.value === 'assessment' ? showCompetModelTests() : handler()"
        >
          <template
              #icon
              v-if="dataTask.btn.icon"
          >
            <mtSvg
                :name="dataTask.btn.icon"
                color="#9FA2B4"
            />
          </template>
          <template #default>
            {{ dataTask.btn.label }}
          </template>
        </mt-button>
      </div>
    </template>
  </mtCard>

  <teleport to="body">
    <DownloadReportPopover
        :visibility="showDownloadReportPopup"
        :reports="dataTask.reports"
        :view_download_html = "true"
        @close="closeDownloadReportPopover"
        @download="downloadReport"
        @downloadHTML="downloadReportHTML"
    />
    <MtDialog size="sm" v-model="isCompetModelOpened" class="test-card__compet">
      <ul>
        <li v-for="mainTest in dataTask.competModel.MainTests">
          <mt-button @click="handler(mainTest.TestName)">
            {{mainTest.TestTitle}}
          </mt-button>
        </li>
      </ul>
    </MtDialog>
  </teleport>
</template>

<script>
import mtShowMoreText from "@/components/UI/mtShowMoreText/index.vue";
import mtCard from "@/components/UI/mtCard/index.vue";
import mtSvg from '@/components/UI/mtSvg/index.vue';
import mtButton from '@/components/UI/mtButton/index.vue';
import mtChip from '@/components/UI/mtChip/index.vue';
import MtDialog from '@/components/UI/mtDialog/mtDialog.vue';
import {TASK_TYPE_ASSESSMENT, TASK_TYPE_CONFIRMATION, TASK_TYPE_EXPERT, TASK_TYPE_TEST, TASK_TYPE_TEST_PRO} from '@/constants/testTypes';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import MtCheckbox from '@/components/UI/mtCheckbox/index.vue';
import FileDownloadCard from '@/components/workspace/assessmentPlans/plans/fileDownloadCard/index.vue';
import DownloadReportPopover from "@/components/workspace/testLibrary/results/DownloadReportPopover/index.vue";
import PlanTestTime from '@/components/workspace/assessmentPlans/planTestTime/index.vue';
// import externalApi from '@/network/external';
import api from '@/network';
import AppTooltip from '@/components/UI/AppTooltip/AppTooltip.vue'
import {activateLinksInText} from "@/services/utils";

export default {
  name: "testCard",
  components: {
    DownloadReportPopover,
    PlanTestTime,
    FileDownloadCard,
    MtCheckbox,
    MtDialog,
    mtChip,
    mtButton,
    mtSvg,
    mtCard,
    mtShowMoreText,
    AppTooltip
  },
  props: {
    test: {
      type: Object,
      default: () => ({
        icon: '',
        type: '',
        title: '',
        description: '',
        deadline: '',
        group: '',
        attempts: '',
        department: '',
        file: ''
      })
    },
    show_progress: Boolean,
  },
  data: () => {
    return {
      clipboardPlans: [],
      clipboardUuid: null,

      selectedResultsReport: [],

      TASK_TYPE_CONFIRMATION,
      dataTask: {},
      showDownloadReportPopup: false,
      isCompetModelOpened: false,
    }
  },
  computed: {
    ...mapState('assessmentPlans/plan', ['isDialogActive', 'isDialogImportActive']),
    ...mapGetters(['authUser']),

    computedClasses() {
      return [
        'test-card',
        'test-card-type--' + this.dataTask.type.value,
        'test-card-status--' + this.dataTask.icon.className
      ]
    },

    dataTaskDescriptionWithLinks() {
      const description = this.dataTask?.description;
      return description ? activateLinksInText(description) : '';
    }
  },
  methods: {
    ...mapMutations('assessmentPlans/plan', ['updateDialogActive', 'updateDialogImportActive']),
    ...mapActions('assessmentPlans/plan/task', ['startTaskSession', 'confirmTask']),
    ...mapActions('results', ['exportResultsReportHTML']),
    ...mapActions('assessmentPlans/plan', ['fetchPlan']),

    OpenImportDialog() {
      this.updateDialogImportActive(true);
    },
    async downloadReportHTML({ variant }) {
      console.log('запускаем отчет html');
      const payload =
          {
            uuid_session: this.selectedResultsReport[0].uuid_session,
            variant: variant
          };

      await this.exportResultsReportHTML(payload).then((response) => {
        if (response.data?.url) {
          window.open(response.data.url, "_blank");
        }
      });
    },
    openDownloadReportPopover() {

      this.selectedResultsReport = [{'uuid_session': this.dataTask.sessionUuid, 'uuid_user': this.dataTask.userUuid}];

      this.showDownloadReportPopup = true;
    },
    closeDownloadReportPopover() {
      this.selectedResultsReport = [];
      // this.clipboardGender = null;
      // this.clipboardFullName = null;
      this.showDownloadReportPopup = false;
    },

    async downloadReport({format, variants, titles}) {
      const payload = [
        {
          format,
          variants,
          selected_results_report: this.selectedResultsReport
        }
      ];

      const response = await api.post('export/results', payload);
      if (response.data?.url) {

        const reportLink = response.data.url;
        const fileNameInfo = response.data.FileNameInfo;
        const isGroup = variants.length > 1;

        if (isGroup) {
          window.open(reportLink, "_blank");
        } else {
          // const response = await externalApi.get(`${ reportLink }`, { responseType: 'blob', });
          const response = await api.get(`export/downloadReport`, { responseType: 'blob', params: { reportLink } })

          if (response.data.size) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;

            //let fileName = `results__${ new Date().toLocaleDateString() }-${ new Date().toLocaleTimeString().replace(/:/g, '_') }.${ type }`;
            let fileName = fileNameInfo['FullName'] + '_' + fileNameInfo['TestName'] + '_' +titles[0] + '_' +fileNameInfo['TestNumber'] + '.' + format;

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
          } else {
            this.$toast.error('Отчёт не найден');
          }
        }
      }
    },
    openModal() {
      this.updateDialogActive(true);
    },
    openLink(url, newTab) {
      try {
        newTab.location = url;
      } catch (e) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
    handler() {
      const planUuid = this.$route.params.planUuid;
      const taskUuid = this.dataTask.uuid;

      if (this.dataTask.type.value === TASK_TYPE_TEST || this.dataTask.type.value === TASK_TYPE_TEST_PRO) {
        const newTab = window.open('about:blank', '_blank');
        if (newTab) {
          newTab.document.write(`
          <html>
            <head>
              <meta name="viewport" content="width=device-width, initial-scale=1.0" />
              <title>Загрузка теста...</title>
              <style>
                html, body {
                  height: 100%;
                  margin: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: #f9f9f9;
                  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                  color: #333;
                  font-size: 1.2rem;
                }
                @media (max-width: 480px) {
                  body {
                    font-size: 1rem;
                    padding: 0 10px;
                    text-align: center;
                  }
                }
              </style>
            </head>
            <body>
              <p>Загрузка теста...</p>
            </body>
          </html>`);
        }

        this.dataTask.btn.loading = true;
        this.startTaskSession({planUuid, taskUuid, testName})
            .then(response => {
              const url = response.data.url;
              this.openLink(url, newTab);

              if(this.dataTask.btn.label === 'Начать выполнение') {
                this.dataTask.btn.label = 'Продолжить выполнение';
              }
            })
            .catch(errorResponse => {
              newTab.close();
              console.log('errorResponse', errorResponse)
              if (errorResponse?.data?.code === 403) {
                this.$toast.error('План оценки заблокирован');
              } else {
                this.$toast.error(errorResponse?.data?.message);
              }
            })
            .finally(() => {
              this.dataTask.btn.loading = false;
              this.fetchPlan({
                uuid: this.$route.params.planUuid,
                withoutLoading:true,
              }).then(response => {
                this.dataTask = this.test;
              });
            })
      } else if (this.dataTask.type.value === TASK_TYPE_EXPERT) {
        this.$router.push({
          name: 'RespondentTaskSingle',
          params: {
            planUuid: this.$route.params.planUuid,
            taskUuid: this.dataTask.uuid
          }
        })
      }
    }
  },
  created() {
    this.dataTask = this.test;
  }
}
</script>

<style
    lang="scss"
    src="./style.scss"
/>


